import PropTypes from 'prop-types'

import {
  Box, Button, Form, SidebarModal,
} from '@domain-group/suit-theme'

import EntitySelectBox from '@components/EntitySelectBox'

import useServiceProduct, { useServiceProductForm } from '@hooks/useServiceProduct'

const CreateServiceProductModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { createServiceProduct } = callbacks

  const {
    callbacks: { createServiceProduct: createFn },
    creating,
  } = useServiceProduct()

  const {
    entityState,
    entityState: {
      service_id,
      title,
    },
    errors,
    handlers,
    saveEnabled,
  } = useServiceProductForm({}, { validateOn: 'change' })

  const createServiceProductPayload = {
    callbacks: {
      action: createFn,
    },
    entityParams: entityState,
    shouldRedirect: true,
    toastText: 'Product Created',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine="Product" />

      <SidebarModal.Content>
        <Box flexDirection="column" flexShrink={0}>
          <Form.Field direction="column" errorMessage={errors.service_id} label="* Service">
            <EntitySelectBox
              entityKey="services"
              name="service_id"
              value={service_id}
              {...handlers}
            />
          </Form.Field>

          <Form.Field
            direction="column"
            errorMessage={errors.title}
            label="* Title"
            marginTop="large"
          >
            <input name="title" value={title} type="text" {...handlers} />
          </Form.Field>

        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          onClick={() => createServiceProduct(createServiceProductPayload)}
          size="large"
        >
          {saveEnabled ? 'Create Product' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

CreateServiceProductModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

CreateServiceProductModal.defaultProps = {
  modalKey: 'CreateServiceProductModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <CreateServiceProductModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
